import script from "./UInstructionStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./UInstructionStep.vue?vue&type=script&setup=true&lang=ts"

import "./UInstructionStep.vue?vue&type=style&index=0&id=efb5a432&lang=css"

const __exports__ = script;

export default __exports__